$(function() {
    // Hero blocks v2 using Splide slider
    var num_splides = document.querySelectorAll('.hero2__section--splide .splide');

    if (num_splides.length > 0) {
        var tabs = document.getElementsByClassName('splide__tab');
        var cur_slide;
        var splide = new Splide('.hero2__section--splide .splide', {
            speed: 700,
            perPage: 1,
            rewind: true,
            pagination: false
        });

        for (var i = 0; i < tabs.length; i++) {
            initTab(tabs[i], i);
        }

        function initTab(tab, i) {
            tab.addEventListener('click', function() {
                splide.go(i);
            });
        }

        splide
            .on('mounted', function() {
                $('.splide').css({
                    'overflow': 'visible',
                    'visibility': 'visible',
                    'height': 'auto'
                });
            }).on('mounted move', function() {
                var tab = tabs[splide.index];

                if (tab) {
                    if (cur_slide) {
                        cur_slide.classList.remove('is-active');
                    }
                    tab.classList.add('is-active');
                    cur_slide = tab;
                }
            });

        splide.mount();
    }
});
